// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';

const requiredPart = t.interface({
  tag: t.literal('BETWEEN_EARTAG'),
  countryCode: t.union([t.string, t.null]),
  field: t.string,
  from: t.Integer,
  to: t.Integer,
});

export const BetweenEarTagFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface BetweenEarTagFilter extends t.TypeOf<typeof BetweenEarTagFilterSchema> {}
